import React from "react";

const Construction  = () => {
    return(
        <>
            <section className="mx-4 md:mx-24">
                <h1 className="text-xl md:text-3xl">Whoops! This page is still under construction.</h1>
                <p className="text-sm md:text-base"> In the meantime, why don't you relax and play some games?</p>
            </section>
            
        </>
    );
}

export default Construction;